import { Component, EventEmitter, Output } from '@angular/core';

@Component({
   selector: 'samweb-chat-confirm-close-dialog',
   templateUrl: './chat-confirm-close-dialog.component.html',
   styleUrls: ['./chat-confirm-close-dialog.component.scss'],
})
export class ChatConfirmCloseDialogComponent {
   @Output()
   public complete = new EventEmitter();

   @Output()
   public cancel = new EventEmitter();

   onComplete() {
      this.complete.emit();
   }

   onCancel() {
      this.cancel.emit();
   }
}
